// 全局配置
const config = {
  // baseUrl:'http://10.2.31.21:8080'|| '/api/',
  // baseUrl:'http://192.168.100.198:8080'|| '/api/',
  baseUrl:'https://www.shanxifh.com/dev-api',
  // baseUrl:'http://47.92.113.165:8080',
  // baseUrl:'http://121.36.113.226:80/dev-api',
  stagnateTime: 60 * 60 * 1000 // 无操作停滞时间  默认1小时
}

export default config
